
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class RazorPaySettingsGrid extends Serenity.EntityGrid<RazorPaySettingsRow, any> {
        protected getColumnsKey() { return RazorPaySettingsColumns.columnsKey; }
        protected getDialogType() { return RazorPaySettingsDialog; }
        protected getIdProperty() { return RazorPaySettingsRow.idProperty; }
        protected getInsertPermission() { return RazorPaySettingsRow.insertPermission; }
        protected getLocalTextPrefix() { return RazorPaySettingsRow.localTextPrefix; }
        protected getService() { return RazorPaySettingsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}
